import { useCallback, useEffect, useMemo, useState } from 'react';

const useTimer = ({ time }) => {
  const [timer, setTimer] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  const minutes = useMemo(() => Math.floor((timer % 3600) / 60), [timer]);
  const seconds = useMemo(() => Math.floor(timer % 60), [timer]);
  const leftTime = useMemo(() => time - timer, [time, timer]);

  const startTimer = useCallback(() => {
    setIsRunning(true);
    setTimer(time);
  }, [time]);

  const end = useCallback(() => {
    setIsRunning(false);
  }, [setIsRunning]);

  useEffect(() => {
    let intervalId;
    if (isRunning) {
      intervalId = setInterval(() => setTimer(timer - 1), 1000);
    }
    if (timer <= 0) {
      end();
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [end, isRunning, setTimer, timer]);

  return { startTimer, isRunning, minutes, seconds, leftTime };
};

export default useTimer;